import { render, staticRenderFns } from "./ClaimDocuments.vue?vue&type=template&id=f2725d74&scoped=true&"
import script from "./ClaimDocuments.vue?vue&type=script&lang=js&"
export * from "./ClaimDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDocuments.vue?vue&type=style&index=0&id=f2725d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2725d74",
  null
  
)

export default component.exports